import { Box, Loader } from "@dbn/omnichannel-design-system-g4p";
import { useQuery } from "../../useAPI";
import * as apis from "../OfferList/api";
import { pipe } from "fp-ts/function";
import * as remoteData from "../../RemoteData";
import * as api from "../api";
import { RuntimeLocaleKey, useFormatMessage } from "../../intl";

interface Props {
  onFailure: () => unknown;
  onContinue: (data: api.GenericLoanResponseOutput) => unknown;
}

export const SaveCustomerOfferSuspense = (props: Props) => {
  const [saveCustomerSelectedOffer] = useQuery(apis.saveCustomerSelectedOffer);
  const formatMessage = useFormatMessage();

  return pipe(
    saveCustomerSelectedOffer,
    remoteData.fold(
      () => (
        <Box hAlignContent="center">
          <Loader
            ariaLabelMessage={formatMessage(
              "generic.loading.alt" as RuntimeLocaleKey
            )}
          />
        </Box>
      ),
      () => <>{props.onFailure()}</>,
      data => <>{props.onContinue(data)}</>
    )
  );
};
